/**
 * Simple date formatting utilities
 * Using native Intl.DateTimeFormat for lightweight bundle
 */

export function format(date: Date, formatStr: string): string {
  const options: Intl.DateTimeFormatOptions = {};
  
  // Parse format string and set options
  if (formatStr.includes('MMM')) {
    options.month = 'short';
  } else if (formatStr.includes('MM')) {
    options.month = '2-digit';
  }
  
  if (formatStr.includes('d')) {
    options.day = 'numeric';
  }
  
  if (formatStr.includes('yyyy')) {
    options.year = 'numeric';
  }
  
  if (formatStr.includes('h:mm')) {
    options.hour = 'numeric';
    options.minute = '2-digit';
  }
  
  if (formatStr.includes('a')) {
    options.hour12 = true;
  }
  
  return new Intl.DateTimeFormat('en-US', options).format(date);
}

export function isToday(date: Date): boolean {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

export function isYesterday(date: Date): boolean {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
}

export function formatRelativeTime(date: Date): string {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  
  return format(date, 'MMM d');
}
